module.exports = __webpack_public_path__ + "pc/img/work_detail3.3e889b43.png";